import { Fragment, type ReactNode } from 'react';

import css from './styles.module.css';

const typedLanguages: string[] = [
	'TypeScript',
	'JavaScript',
	'Golang',
	'HTML',
	'CSS',
	'PHP',
	'SQL',
	'Ruby',
	'Python',
];

const toolsAndFrameworks: string[] = [
	'Git',
	'React',
	'Bun',
	'Node',
	'Docker',
	'Rails',
	'WordPress',
	'Photoshop',
	'Illustrator',
];

export default function Skills(): ReactNode {
	return (
		<main className={css.wrapper}>
			<div className={css.wrap}>
				<h2 data-scroll-reveal>Skills.</h2>

				<article className={css.skill} data-scroll-reveal>
					<h3>
						Languages
						<strong>Spoken</strong>
					</h3>
					<p>
						<span>Svenska</span>, <span>English</span>, bisschen{' '}
						<span>Deutsch</span>
					</p>
				</article>

				<article className={css.skill} data-scroll-reveal>
					<h3>
						Languages
						<strong>Typed</strong>
					</h3>
					<p>
						{typedLanguages.map((lang, n) => (
							<Fragment key={`lang:${n}`}>
								<span>{lang}</span>
								{n === typedLanguages.length - 1 ? '' : ', '}
							</Fragment>
						))}
					</p>
				</article>

				<article className={css.skill} data-scroll-reveal>
					<h3>
						<strong>Tools</strong>
					</h3>
					<p>
						{toolsAndFrameworks.map((item, n) => (
							<Fragment key={`tool:${n}`}>
								<span>{item}</span>
								{n === toolsAndFrameworks.length - 1 ? '' : ', '}
							</Fragment>
						))}
					</p>
				</article>
			</div>
		</main>
	);
}
